<template>
    <Head title="Profile" />
    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('teaser:verifiedEmailHeadlines')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <div class="space-y-6">
                    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                        <p class="text-gray-900">{{ translate('body:verifiedEmailHeadline', {email}) }}</p>
                    </div>
                </div>
                <div class="p-5 text-right">
                    <Link :href="route('profile_display_localized')" class="inline-flex w-full justify-center border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm">
                        {{ translate('body:toProfileButtonLabel') }}
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, useForm, usePage} from '@inertiajs/inertia-vue3'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ExclamationTriangleIcon, BanknotesIcon, CreditCardIcon } from '@heroicons/vue/24/outline'
import Teaser from "../../Components/Common/Teaser";
import translate from "../../../lang";
import {computed, ref} from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Link } from '@inertiajs/inertia-vue3'
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/20/solid'
import {
    FireIcon,
    CloudArrowUpIcon,
    PaperAirplaneIcon,
    ArchiveBoxIcon,
    ArrowRightCircleIcon,
    ChevronDownIcon,
    DocumentDuplicateIcon,
    HeartIcon,
    PencilIcon,
    TrashIcon,
    UserPlusIcon,
    ShareIcon,
    DocumentMagnifyingGlassIcon,
    ArrowUpRightIcon,
    XMarkIcon,
    EllipsisVerticalIcon
} from '@heroicons/vue/20/solid'
import {
    ArrowPathIcon,
    ClockIcon,
    LinkIcon
} from '@heroicons/vue/24/outline';
import {
    ExclamationCircleIcon
} from '@heroicons/vue/24/solid';

import {Inertia} from "@inertiajs/inertia";
import Burn from './Dialogs/Burn';
import Transfer from './Dialogs/Transfer';
import Recreate from './Dialogs/Recreate';
import DeleteUnfinished from "./Dialogs/DeleteUnfinished";
import MetaData from "./Dialogs/MetaData";
import DeleteBurned from "./Dialogs/DeleteBurned";
import Transactions from "./Dialogs/Transactions";
import Billing from "./Dialogs/Billing";
import LoadingDots from "./Components/LoadingDots";

export default {
    components: {
        ExclamationCircleIcon,
        XMarkIcon,
        CreditCardIcon,
        LoadingDots,
        BanknotesIcon,
        EllipsisVerticalIcon,
        DeleteUnfinished,
        Burn,
        Recreate,
        Transfer,
        MetaData,
        DeleteBurned,
        Transactions,
        Billing,
        CloudArrowUpIcon,
        LinkIcon,
        Teaser,
        Link,
        Head,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ArchiveBoxIcon,
        ArrowRightCircleIcon,
        ChevronDownIcon,
        DocumentDuplicateIcon,
        HeartIcon,
        PencilIcon,
        TrashIcon,
        UserPlusIcon,
        PaperAirplaneIcon,
        DocumentMagnifyingGlassIcon,
        ArrowUpRightIcon,
        FireIcon,
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        ExclamationTriangleIcon,
        ShareIcon,
        ArrowPathIcon,
        ClockIcon
    },
    props: {
    },
    setup() {

        let user = usePage().props.value.auth.user;
       return {
            translate: translate('profile'),
            email: user.email,
        };
    }
}
</script>
